import { Container, Row, Col } from "react-bootstrap";
import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const skillCategories = [
    {
      title: "Frontend Development",
      skills: ["React.js", "JavaScript (ES6+)", "HTML5", "CSS3 / Sass", "Bootstrap", "Tailwind CSS"],
      icon: "💻"
    },
    {
      title: "Data Engineering",
      skills: ["Automation Scripts", "ETL Pipelines", "Data Extraction", "Large-scale Processing"],
      icon: "📊"
    },
    {
      title: "Cloud & DevOps",
      skills: ["Microsoft Azure", "AWS (EC2/S3)", "VM Management", "DNS/SSL"],
      icon: "☁️"
    },
    {
      title: "Backend & APIs",
      skills: ["Node.js", "Express.js", "REST APIs", "SQL (PostgreSQL/MySQL)", "Firebase", "Google Apps Script"],
      icon: "⚙️"
    },
    {
      title: "Analytics & SEO",
      skills: ["Hotjar", "Microsoft Clarity", "SEO Optimization", "User Behavior Tracking"],
      icon: "🔍"
    },
    {
      title: "Tools & Automation",
      skills: ["Email Automation", "Web Scraping"],
      icon: "🛠️"
    }
  ];

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-section-content">
              <h2>Technical Expertise</h2>
              <p>A comprehensive toolkit built through developing national-level platforms and scalable data solutions.</p>
              <Row className="justify-content-center">
                {skillCategories.map((category, index) => (
                  <Col md={4} sm={6} key={index} className="skill-col">
                    <div className="unified-card skill-card">
                      <div className="skill-icon">{category.icon}</div>
                      <h3>{category.title}</h3>
                      <div className="skill-list">
                        {category.skills.map((skill, idx) => (
                          <span key={idx} className="skill-tag">
                            {skill}{idx !== category.skills.length - 1 && ", "}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
